import { api } from './_request';

 export const get = (data) => {
 	return (dispatch) => {
				dispatch({
				type: 'LIST',
					payload: data
 				});
 	}
 };

export const save = (item, callback) => {
	return (dispatch) => {

		dispatch({ type: 'SAVE' });

		api().post('tipos_movimiento', item).then(function(response) {

			if(response.status === 200) {

				dispatch({
					type: 'SAVE_SUCCESS',
					payload: response.data
				});

				if(typeof callback === 'function') callback(response.data);

			}
			else{
				dispatch({ type: 'SAVE_FAILURE' });
			}

		})
		.catch(function(error) {
			dispatch({ type: 'SAVE_FAILURE' });
		});

	}
};

export const update = (item, callback) => {
	return (dispatch) => {

        
		dispatch({ type: 'SAVE' });

		api().post(`tipos_movimiento/${item.id}`, item)
		.then(function(response)
		{
			if(response.status === 200)
			{
				dispatch({
					type: 'UPDATE_SUCCESS',
					payload: response.data
				});
				console.log('tipos_movimiento action----->', response.data);

				if(typeof callback === 'function') callback(response.data);
			}
			else
			{
				dispatch({ type: 'SAVE_FAILURE' });
			}
		})
		.catch(function(error) {
			dispatch({ type: 'SAVE_FAILURE' });
		});

	}
};

export const guardando = () => {
	return (dispatch) => {
		dispatch({ type: 'SAVE' });
	}
};

export const exito = (item) => {
	return (dispatch) => {
		dispatch({
					type: 'UPDATE_SUCCESS',
					payload: item
				});
	}
};

export const alerta = (alerta) => {
		return (dispatch) => {
			dispatch({
						type: 'SAVE_ALERTA',
						payload: alerta
					});
		}
	};


// WEBPACK FOOTER //
// ./src/actions/comprasespeciales.js